import React from "react";
import { useTranslation } from "react-i18next";
import "./style.scss";
import { useNavigate } from "react-router";
import {addToLog} from "../../helpers/ApiHelper";

export interface LoginDialogProps {
    onYes: () => void;
}

const LoginDialog = ({ onYes }: LoginDialogProps) => {
    const [t] = useTranslation();
    const navigate = useNavigate();

    const goToMenu = () => {
        addToLog(`Set customer = No`);
        navigate("/menu#ns");
    }

    const goNext = () => {
        addToLog(`Set customer = Yes`);
        onYes();
    }

    return <div className="LoginDialog">
        <div className="content">
            <div className="title">{t("logIntoAccount")}</div>
            <div className="buttons">
                <div className="button dark" onClick={goNext}>{t("yes")}</div>
                <div className="button" onClick={goToMenu}>{t("noThanks")}</div>
            </div>
            <div className="description">{t("loginDescription")}</div>
        </div>
    </div>
}

export default LoginDialog;
